import React, {createRef, memo, useContext, useEffect, useState} from 'react';
import { useQueryClient } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import moment from "moment";
import __ from "lodash";
import MaterialTable from "@material-table/core";
import {Icon, MenuItem, Select, TablePagination, useTheme} from "@material-ui/core";

import {
  defaultComponents,
  defaultComponentsScroll,
  FullWidthFilter,
  MaterialTableBody
} from '../../../controls/Material-Table-Components';
import SystemContext from "../../../SystemContext";
import {ColumnWidth, renderBooleanFilter,} from "../../../blocks/ColumnHelper";
import useDimensions from "../../../blocks/useDimensions";
import { useHandoverItems } from "../../../services/flights";

import HandoverList from "./HandoverList";




const HandoverMonthLists = (_props) => {
  const {isAuthenticated, user} = useAuth0();
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const eventBus = SystemData.eventBus;

  const props = {
    ..._props
  }
  const classes = props.classes;
  const colours = SystemData.colours;

  const tableRef = createRef({state: {lastEditingRow: false}});
  const month = props.month;
  const year = props.year;

  const queryClient = useQueryClient();
  const extraKeys = [year, month];


  const handoverItems = useHandoverItems({tableRef, queryClient, extraKeys});
  const [state] = useState({
    canEdit: props.canEdit,
    canEditFuelLogs: props.canEditFuelLogs,
    year: props.year,
    month: props.month
  });

  let selectedRow = -1;

  const refreshList = async () => {
    queryClient.invalidateQueries(["HandoverItems"]);
  }

  const getColumns = (props) => {

    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit ? "always" : "never",
      emptyValue: "",
      initialEditValue: "",
    };

    return [
      //{...validatorColumn},
      {
        ...baseColumn,
        ...ColumnWidth(70, undefined, undefined, undefined, undefined, undefined, false),
        title: "Date",
        field: "date",
        render: rowData => {
          const flightDate = moment(rowData.date, "YYYY-MM-DD HH:mm:ss");
          return ( <span>{flightDate.format("DD MMM")}</span>);
        },
        filtering: false,
      },
      {
        ...baseColumn,
        ...ColumnWidth(100, undefined, undefined, undefined, undefined, undefined, false),
        title: "Shift",
        field: "shift",
        editable: state.canEdit ? "always" : "never",
        emptyValue: "",
        initialEditValue: "",
        editComponent: (props) => {
          const comboValues = [{"code":"DAY","value":"Day"}, {"code":"NIGHT","value":"Night"}];
          return (
            <Select
              style={{width: "100%"}}
              value={props.value == null?'':props.value}
              onChange={
                (evt, data) => {
                  props.onChange(data.props.value);
                }
              }
              renderValue={(value) => `${value}`}
            >
              {(comboValues) ?
                comboValues.map((record) => {
                  return (
                    <MenuItem key={record.code} value={record.value}>{record.value}</MenuItem>
                  );
                }) :
                null
              }
            </Select>
          )
        },
        filtering: false,
      },
      {
        ...baseColumn,
        ...ColumnWidth(70,undefined,undefined,undefined,undefined,undefined,false),
        title: "Items",
        field: "items",
        filtering: false,
      },
      {
        ...baseColumn,
        ...ColumnWidth(70,undefined,undefined,undefined,undefined,undefined,false),
        title: "Outstanding",
        field: "outstanding",
        filtering: false,
      },
      {
        ...baseColumn,
        title: "",
        field: "",
      },
     ];
  };

  const ListsRows = memo((props) => {

    return (
      <MaterialTable
        tableRef={tableRef}
        style={{
          border: "none",
          boxShadow: "none",
          borderRadius: 0,
        }}
        options={{
          actionsColumnIndex: -1,
          cellStyle: {
            padding: "8px 2px",
          },
          headerStyle: {
            backgroundColor: theme.palette.tableHeader.backgroundColor,
            color: theme.palette.tableHeader.textColor,
            padding: "2px",
          },
          rowStyle: (rowData)=> ({opacity: rowData.cancelled?0.5:1}),
          toolbarButtonAlignment: "right",
          pageSize: 10,
          detailPanelType: "single",
          padding: "dense",
          //paging: false
          //paginationType: "stepped"
        }}
        actions={[
          {
            icon: 'refresh',
            tooltip: "Refresh List",
            isFreeAction: true,
            onClick: (e) => {
              refreshList();
            }
          },
        ]}
        components={{
          ...defaultComponents,
          Pagination: (props) => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[10, 20, 30]}
            />
          ),
        }}
        detailPanel={[
          {
            tooltip: "Show Handover List Details",
            render: (rowData) => {
              return (
                <div style={{backgroundColor: "#f2f2f2", height: 300}}>
                  <div className={classes.rooted}
                       style={{ minHeight: `calc(100vh - ${(940)}px)`, height: `calc(100vh - ${(940)}px)`, width: `calc(100vw - 140px)`, maxWidth: `calc(100vw - 140px)`}}
                  >
                    <HandoverList date={rowData.date} shift={rowData.shift} canEdit={state.canEdit} classes={classes}/>
                  </div>
                </div>
              );
            },
          },
        ]}
        title="Handover Lists"
        columns={getColumns({canEdit: state.canEdit})}
        data={props.data}
      />
    )
  });

  return (isAuthenticated &&
      <div  style={{width: "100%", marginLeft: 20, noWidth: "calc(100% - 24px)"}}>
        <ListsRows data={handoverItems.data}/>
      </div>
  );

}

export default HandoverMonthLists;
